import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NODE_ENV === "production" ? "../EntryPointService/api/EntryPoint" : "/api",
  }),
  tagTypes: [
  ],
  endpoints: (builder) => ({})
})

export default api
